export default __webpack_public_path__ + "static/media/ecommerce.6afcd913.png";